import React from 'react';
import { useNavigate } from 'react-router-dom';

export const ContactTeaser = () => {
  const navigate = useNavigate();

  return (
    <div className="contact-teaser-section">
      <div className="contact-teaser-container">
        <div className="teaser-content">
          <h2>Masz pytania?</h2>
          
          <p className="teaser-text">
            Maksymalnie ułatwiliśmy zamawianie — wystarczy wybrać produkt i ilość ton. Oraz ustawić pinezkę za pomocą Google Maps.<br />
            Ale jeśli masz jakiekolwiek pytania, wątpliwości lub potrzebujesz indywidualnej wyceny — 
            jesteśmy do Twojej dyspozycji.
          </p>
          <button 
            onClick={() => navigate('/kontakt')}
            className="contact-teaser-button"
          >
            Skontaktuj się z nami
          </button>

          <p className="teaser-subtext">
            Odpowiadamy zwykle w ciągu kilku godzin
          </p>
        </div>
      </div>
    </div>
  );
};
